import React, { useState } from "react";
import classNames from "../../utils/classNames";

let timeout;

function validateInput(value) {
  // Regular expression to allow only alphabetic characters and spaces
  // It disallows numbers, special characters, and punctuation.
  const regex = /^[A-Za-z\s]*$/;
  return regex.test(value);
}

function Search({
  className,
  fields,
  onSubmit,
  buttonLabel,
  searchIcon,
  placeholder,
}) {
  const [name, setName] = useState("");
  const [isValid, setIsValid] = useState(true);

  function onChange(value) {
    const where = {};
    clearTimeout(timeout);
    const or = [];
    Object.keys(fields).forEach((field) => {
      const options = fields[field];
      if (options.type === "string") {
        const query = {};
        if (options.objectField) {
          query[field] = {
            [options.objectField]: { $regex: value, $options: "i" },
          };
        } else {
          query[field] = { $regex: value, $options: "i" };
        }
        or.push(query);
      } else if (options.type === "Boolean") {
        const query = {};
        query[field] = value === "true";
        or.push(query);
      } else if (options.type === "Number") {
        const numberValue = parseInt(value);
        const query = {};
        if (!isNaN(numberValue)) {
          query[field] = { $eq: numberValue };
        }
        or.push(query);
      } else if (options.type === "Pointer") {
        const query = {};
        query[field] = { $regex: value, $options: "i" };
        or.push(query);
      }
    });

    where.$or = or;

    timeout = setTimeout(() => {
      onSubmit(where);
    }, 300);
  }

  function handleSubmit() {
    if (!name) return;

    const where = {};
    const or = [];
    Object.keys(fields).forEach((field) => {
      const options = fields[field];
      if (options.type === "string" || options.type === "String") {
        const query = {};
        query[field] = { $regex: name, $options: "i" };
        or.push(query);
      } else if (options.type === "boolean" || options.type === "Boolean") {
        const query = {};
        query[field] = name === "true";
        or.push(query);
      } else if (options.type === "pointer" || options.type === "Pointer") {
        const query = {};
        query[field] = { $eq: name }; // Assuming `name` is the object ID to search for
        or.push(query);
      }
    });
    where.$or = or;
    onSubmit(where);
  }

  function onNamechange(input) {
    const isInputValid = validateInput(input);

    if (!isInputValid) {
      setIsValid(false);
      return;
    }

    setIsValid(true);
    setName(input);
  }

  return (
    <>
      {/* Conditionally render error message */}
      {!isValid && (
        <p className="text-danger mb-0" style={{ fontSize: ".875rem" }}>
          Please remove special characters, numbers and punctuations.
        </p>
      )}
      <div className={classNames("input-group", className)}>
        {searchIcon && (
          <span className="input-group-text rounded-start-pill bg-white">
            <i className="bi bi-search" />
          </span>
        )}

        <input
          {...(!buttonLabel
            ? { onChange: (e) => onChange(e.target.value) }
            : { onChange: (e) => onNamechange(e.target.value) })}
          type="search"
          className="form-control"
          placeholder={placeholder || "Search"}
        />
        {buttonLabel ? (
          <button
            type="button"
            className="btn fw-medium rounded-end-pill"
            style={{
              fontSize: ".8rem",
              background: "#fdb007",
              border: "1px solid rgba(0, 0, 0, .1)",
            }}
            disabled={!name || !isValid}
            onClick={handleSubmit}
          >
            {buttonLabel}
          </button>
        ) : null}
      </div>
    </>
  );
}

export default Search;
